module.exports = {"singular":"Veranstaltungsort","plural":"Veranstaltungsorte"};